import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RessourceService } from 'src/app/services/ressource/ressource.service';
import { Honoraire } from 'src/app/utils/interfaces/new/honoraire.interface';
import { RessourceSetting } from 'src/app/utils/interfaces/new/RessourceSetting';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-honoraires',
  templateUrl: './honoraires.fragment.html',
  styleUrls: [
    './honoraires.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class HonorairesFragment implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public dateSoins: Date;
  public totalPrice: string;
  public ccam: any[] = [];
  public ngap: any[] = [];
  public currentFacture?: Honoraire;

  public actes: string;
  public modePaiement: string = 'Espèce';
  public typeFacture: string = 'fse';

  private _resourceId: string;
  public ressourceSetting: RessourceSetting[];
  public infosModeJuxta: boolean;

  public formGroup: FormGroup;
  public actesList = [{ id: 1, libelle: 'actes en série' }, { id: 2, libelle: 'aide médicale gratuite' }];
  public typesList = [{ id: 'fse', libelle: 'FSE' }, { id: 'libre', libelle: 'Libre' }];
  public honorairesList = [{ id: 1, libelle: '700000 Honoraires conventionnés' }, { id: 2, libelle: '700001 Honoraires non conventionnés' }];

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeHonorairesModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
    private _ressourceSrv: RessourceService,
  ) { }

  async ngOnInit() {
    this.dateSoins = this.dateSoins ? this.dateSoins : new Date();
    for (const ngap of this.ngap) {
      if (this.actes != undefined) {
        this.actes = this.actes += `+ ${ngap.cleActe}`
      } else {
        this.actes = ngap.cleActe;
      }
    }
    for (const ccam of this.ccam) {
      if (this.actes != undefined) {
        this.actes = this.actes += `+ ${ccam.code}`
      } else {
        this.actes = ccam.code;
      }
    }

    const currentProfilStr = localStorage.getItem('currentProfil');
    if (currentProfilStr && currentProfilStr !== '') {
      const currentProfil = JSON.parse(currentProfilStr);
      this._resourceId = currentProfil.id;
    }

    await this.initSettings();

    if (this.currentFacture) {
      this.switchModePaiement(this.currentFacture.typePaiement);
    }


    this.formGroup = this._formBuilder.group({
      actes: [this.currentFacture ? this.currentFacture.typeActes : ''],
      honoraires: [this.currentFacture ? this.currentFacture.typeHonoraires : ''],
      print: [''],
      typeFacture: [this.infosModeJuxta ? this.currentFacture ? this.currentFacture.typeFacture :'fse' : 'libre']
    });
  }

  private async initSettings() {
    this.ressourceSetting = await this._ressourceSrv.getResourceSettings(this._resourceId, 'profil');
    if (this.ressourceSetting.length > 0) {
      const juxtaInfos = this.ressourceSetting.find(x => x.settingKey === "mode_juxta").settingValue;
      this.infosModeJuxta = juxtaInfos === 'true' ? true : false;
    }
  }

  public switchModePaiement(value: string) {
    switch (value) {
      case 'Chèque': {
        this.modePaiement = value;
        break;
      }
      case 'Espèce': {
        this.modePaiement = value;
        break;
      }
      case 'Carte Bancaire': {
        this.modePaiement = value;
        break;
      }
      default: {
        return '';
        break;
      }
        return this.modePaiement;
    }
  }

  public onSubmit() {
    let object = {
      modePaiement: this.modePaiement,
      totalPrice: this.totalPrice,
      typeFacture: this.formGroup.get('typeFacture').value ? this.formGroup.get('typeFacture').value : 'fse',
      typeHonoraires: this.formGroup.get('honoraires').value,
      typeActes: this.formGroup.get('actes').value,
    }
    this.closeHonorairesModal(object);
  }

  public closeHonorairesModal(object?: any): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit();
    }
  }
}
